import type {Component} from 'src/typings';
import './jp-slider.less';
import type {IOnInit} from 'angular';
import {deepFreeze} from 'shared/utils/object-utils';

const SLIDER_DEFAULT_SETTINGS = deepFreeze({
    waitForAnimate: false,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 5000,
    slidesToScroll: 1,
    dots: false
});

export class JpSliderComponentController implements JpSliderComponentBindings, IOnInit {
    public mode: string;
    public settings: any;
    public arrows: boolean;
    public initialSettings: any;
    public showArrows = false;

    public $onInit(): void {
        if (this.mode === 'padded-single') {
            this.initialSettings = {
                arrows: false,
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '16%',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            centerMode: false
                        }
                    }
                ]
            };
        } else if (this.mode === 'multiple') {
            this.initialSettings = {
                slidesToShow: 4,
                prevArrow: '#btn-slider-prev',
                nextArrow: '#btn-slider-next',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2
                        }
                    }
                ]
            };
        }

        if (typeof this.arrows === 'boolean' && this.arrows) {
            this.showArrows = true;
            this.initialSettings.arrows = true;
            this.initialSettings.prevArrow = 'jp-slider .arrow-prev';
            this.initialSettings.nextArrow = 'jp-slider .arrow-next';
        }

        this.settings = Object.assign({}, SLIDER_DEFAULT_SETTINGS, this.initialSettings, this.settings);
    }
}

/**
 * @ngdoc component
 * @name jpSlider
 * @module portaro.components
 *
 * @description
 *
 */
export default class JpSliderComponent implements Component<JpSliderComponentBindings> {
    public static componentName = 'jpSlider';

    public templateUrl = require('./jp-slider.tpl.ftl');

    public transclude = true;

    public bindings = {
        mode: '@',
        settings: '<',
        arrows: '<'
    } as const;

    public controller = JpSliderComponentController;
}

interface JpSliderComponentBindings {
    mode: string;
    settings: any;
    arrows: boolean;
}
